import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import DataSync from './DataSync.js';
import LogsView from './LogsView.js';
import BullBoardView from './BullBoardView.js';
import useStyles from './styles.js';

const WebhookDataSync = () => {
  const classes = useStyles();
  const [view, setView] = useState('sync');

  return (
    <div className={classes.container}>
      <div className={classes.buttonContainer}>
        <Button variant="contained" color="primary" onClick={() => setView('sync')}>
          Nouvelle Synchronisation
        </Button>
        <Button variant="contained" color="primary" onClick={() => setView('logs')}>
          Voir les Logs
        </Button>
        <Button variant="contained" color="primary" onClick={() => setView('sync-tracking')}>
          Suivi de synchro
        </Button>
      </div>
      {view === 'sync' && <DataSync />}
      {view === 'logs' && <LogsView />}
      {view === 'sync-tracking' && <BullBoardView />}
    </div>
  );
};

export default WebhookDataSync;